<template>
  <div id="voteDetail">
    <page-header :noBack="true">
      投票
    </page-header>
    <div class="infor_wrap">
      <div class="headimgs">
        <img class="headimg" :src="infor.photo" alt="">
      </div>
      <div class="infors">
        <div class="infor">
          <div class="name">{{infor.name}}</div>
          <div class="title">昵称/姓名</div>
        </div>
        <div class="infor">
          <div class="num red">{{infor.canvassNum}}</div>
          <div class="title">当前票数</div>
        </div>
        <div class="infor">
          <div class="num">{{infor.userNum}}</div>
          <div class="title">用户编号</div>
        </div>
      </div>
      <div class="address">
        <div class="area">{{infor.district}}{{infor.town}}</div>
        <div class="addre">{{infor.company}}</div>
      </div>
    </div>
    <div class="submit_btn" @click="Toast('请下载APP进行投票')">投TA一票</div>
    <div class="download_wrap">
      <div class="left_wrap">
        <img class="logo" src="../assets/img/logo_1.png" alt="">
        <div class="name">学习国防</div>
      </div>
      <router-link to="/download" tag="div" class="btn">下载App</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "voteDetail",
  data() {
    return {
      id: this.$route.query.id,
      infor: {}
    };
  },
  mounted () {
    this.getInfo();
  },
  methods: {
    getInfo () {
      this.axios.get('/xxgf-api/activity/match/match/user?id=' + this.id)
        .then(({data}) => {
          if (data.code === 200) {
            this.infor = data.data;
          }
        });
    },
  }
};
</script>

<style lang="scss">
#voteDetail {
  padding-top:94px;
  padding-bottom:120px;
  background:#D72F1D;
  .infor_wrap{
    width:690px;
    margin: 40px auto 0;
    background: #fff;
    border-radius: 14px;
    height:925px;
    padding:40px;
    .headimgs{
      width:610px;
      height:610px;
      .headimg{
        width:100%;
        height:100%;
        object-fit: cover;
        border-radius: 4px;
      }
    }
    .infors{
      height:150px;
      width:100%;
      display:flex;
      border-bottom:1px solid #EEEEEE;
      .infor{
        flex:1;
        text-align:Center;
        line-height:50px;
        padding-top:20px;
        position:relative;
        &:after{
          width:1px;
          height:68px;
          background:#DEDEDE;
          content: '';
          display:block;
          position: absolute;
          right:0;
          top:50%;
          margin-top:-39px;
          z-index:1;
        }
        &:last-child{
          &:after{
            display:none;
          }
        }
        .name{
          color:#333;
          font-size:37px;
        }
        .title{
          font-size:20px;
          color:#999;
        }
        .num{
          font-size:30px;
          &.red{
            color:#D72F1D;
          }
        }
      }
    }
    .address{
      font-size:18px;
      color:#777;
      line-height:40px;
      margin-top:20px;
    }
  }
  .submit_btn{
    width:690px;
    height:94px;
    border-radius: 47px;
    margin:46px auto 0;
    background:linear-gradient(180deg, #FFD06E, #FF9D28);
    text-align:center;
    line-height:94px;
    font-size:32px;
    color:#fff;
  }
}
</style>
